import Skeleton from 'components/3catinfo/Skeleton/Skeleton';
import styles from './autor.module.scss';

const AutorSkeleton = (props) => {
    return (
        <div>
            <section className={styles.cos}>
                <Skeleton titol className={styles.titol} num={2} />
                <div className={`${styles.imatgeWrapper} ${styles.imatgeSkeleton}`}>
                    <Skeleton imatge />
                </div>
            </section>
        </div>
    );
};

export default AutorSkeleton;
